export const routerView = [

    //Index
    {
        path: '/',
        name: 'Dashboard',
        meta: {
            title: '首页',
            keepAlive: false
        },
        component: resolve => require(['~/views/Home'], resolve),
    },
    //System Manage
    {
        path: '/user_list',
        name: 'UserList',
        meta: {
            title: '用户管理',
            keepAlive: false
        },
        component: resolve => require(['~/views/SystemManage/UserManage'], resolve),
    },
    {
        path: '/role_list',
        name: 'RoleList',
        meta: {
            title: '角色管理',
            keepAlive: false
        },
        component: resolve => require(['~/views/SystemManage/RoleManage'], resolve),
    },
    {
        path: '/dept',
        name: 'Dept_Manage',
        meta: {
            title: '部门管理',
            keepAlive: false
        },
        component: resolve => require(['~/views/SystemManage/DeptManage'], resolve),
    },
    {
        path: '/dict',
        name: 'Dict_Manage',
        meta: {
            title: '字典管理',
            keepAlive: false
        },
        component: resolve => require(['~/views/SystemManage/DictManage'], resolve),
    },
    {
        path: '/menu',
        name: 'Menu_Manage',
        meta: {
            title: '菜单管理',
            keepAlive: false
        },
        component: resolve => require(['~/views/SystemManage/MenuManage'], resolve),
    },
    {
        path: '/loginLog',
        name: 'Login_Log',
        meta: {
            title: '登录日志',
            keepAlive: true
        },
        component: resolve => require(['~/views/SystemManage/LoginLog'], resolve),
    },
    {
        path: '/business_log',
        name: 'Business_Log',
        meta: {
            title: '业务日志',
            keepAlive: true
        },
        component: resolve => require(['~/views/SystemManage/BusinessLog'], resolve),
    },
    {
        path: '/notice',
        name: 'Notice_Manage',
        meta: {
            title: '通知管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/SystemManage/NoticeManage'], resolve),
    },
    {
        path: '/data_permission',
        name: 'Data_Permission',
        meta: {
            title: '数据权限分组',
            keepAlive: true
        },
        component: resolve => require(['~/views/SystemManage/DataPermission'], resolve),
    },
    {
        path: '/time_task',
        name: 'Time_Task',
        meta: {
            title: '定时任务管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/SystemManage/TimeTaskManage'], resolve),
    },
    //order manage
    {
        path: '/platForm_order',
        name: 'Platform_Order',
        meta: {
            title: '平台订单',
            keepAlive: true
        },
        component: resolve => require(['~/views/OrderManage/PlatformOrder'], resolve),
    },
    {
        path: '/so_order',
        name: 'So_Order',
        meta: {
            title: '实仓订单',
            keepAlive: true
        },
        component: resolve => require(['~/views/OrderManage/SoOrder'], resolve),
    }, {
        path: '/virtual_order',
        name: 'Virtual_Order',
        meta: {
            title: '虚仓订单',
            keepAlive: true
        },
        component: resolve => require(['~/views/OrderManage/VirtualOrder'], resolve),
    },

    {
        path: '/import_order',
        name: 'Import_Order',
        meta: {
            title: '订单明细导入',
            keepAlive: true
        },
        component: resolve => require(['~/views/OrderManage/ImportOrder'], resolve),
    },

    //售后
    {
        path: '/exchange_order',
        name: 'Exchange_Order',
        meta: {
            title: '退换货管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/AfterSale/ExchangeOrder'], resolve),
    },
    {
        path: '/refund_order',
        name: 'Refund_Order',
        meta: {
            title: '退款单管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/AfterSale/RefundOrder'], resolve),
    },
    {
        path: '/import_refund',
            name: 'import_refund',
        meta: {
        title: '导入售后单',
            keepAlive: true
    },
        component: resolve => require(['~/views/AfterSale/importRefund'], resolve),
    },
    /*{
        path: '/sku_manage',
        name: 'Sku_Manage',
        meta: {
            title: 'sku管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/MaintainGoods/SkuManage'], resolve),
    },*/
    {
        path: '/sku',
        name: 'sku',
        meta: {
            title: 'sku管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/MaintainGoods/sku/'], resolve),
    },
    {
        path: '/kingdee/sku',
        name: 'kingdee_sku',
        meta: {
            title: '【苍穹】sku管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/MaintainGoods/sku/kingdee/'], resolve),
    },
    {
        path: '/sku_transform',
        name: 'Sku_Transform',
        meta: {
            title: 'sku转码',
            keepAlive: true
        },
        component: resolve => require(['~/views/MaintainGoods/sku/transForm'], resolve),
    }, {
        path: '/goods_manage',
        name: 'Goods_Manage',
        meta: {
            title: '商品管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/MaintainGoods/GoodsManage'], resolve),
    }, {
        path: '/combo_product',
        name: 'Combo_Product',
        meta: {
            title: '组合商品',
            keepAlive: true
        },
        component: resolve => require(['~/views/MaintainGoods/ComboProduct'], resolve),
    }, {
        path: '/brand_manage',
        name: 'Brand_Manage',
        meta: {
            title: '品牌管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/MaintainGoods/BrandManage'], resolve),
    }, {
        path: '/merchant_manage',
        name: 'Merchant_Manage',
        meta: {
            title: '商家管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/MaintainGoods/MerchantManage'], resolve),
    },
    {
        path: '/warehouse_manage',
        name: 'Warehouse_Manage',
        meta: {
            title: '仓库管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/Inventory/Warehouse'], resolve),
    },
    {
        path: '/goods_stock',
        name: 'Goods_Stock',
        meta: {
            title: '商品库存',
            keepAlive: true
        },
        component: resolve => require(['~/views/Inventory/GoodsStock'], resolve),
    },
    {
        path: '/stockPlan',
        name: 'Stock_Plan',
        meta: {
            title: '商品库存',
            keepAlive: true
        },
        component: resolve => require(['~/views/Inventory/StockPlan'], resolve),
    },

    {
        path: '/ml_sale',
        name: 'ml_sale',
        meta: {
            title: '迈蓝销售报表',
            keepAlive: true
        },
        component: resolve => require(['~/views/MailanManage/SaleManager'], resolve),
    },
    
    //店铺管理
    {
        path: '/shop_manage',
        name: 'Shop_Manage',
        meta: {
            title: '店铺管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/PlatformManage/ShopManage'], resolve),
    },

     //发货配置
     {
        path: '/shop_logic',
        name: 'Shop_Logic',
        meta: {
            title: '发货配置',
            keepAlive: true
        },
        component: resolve => require(['~/views/Setting/ShopLogic'], resolve),
    },

    {
        path: '/manufacture',
        name: 'Manu_Manage',
        meta: {
            title: '厂商管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/Manufacturer'], resolve),
    },
    {
        path: '/platform_Manage',
        name: 'Platform_Manage',
        meta: {
            title: '平台管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/PlatformManage/PlatformManagement'], resolve),
    },
    {
        path: '/purchasing_agent',
        name: 'Purchasing_Agent',
        meta: {
            title: '供应商管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/PurchasingManage/PurchasingAgent'], resolve),
    },
    {
        path: '/purchasing_order',
        name: 'Purchasing_Order',
        meta: {
            title: '采购单管理',
            keepAlive: true
        },
        component: resolve => require(['~/views/PurchasingManage/PurchasingOrder'], resolve),
    }, {
        path: '/express_company',
        name: 'Express_Company',
        meta: {
            title: '快递公司设置',
            keepAlive: true
        },
        component: resolve => require(['~/views/Setting/ExpressCompany'], resolve),
    },
    {
        path: '/export_task',
        name: 'Export_Task',
        meta: {
            title: '导出任务',
            keepAlive: true
        },
        component: resolve => require(['~/views/MyTask/ExportTask'], resolve),
    },
    {
        path: '/ecp_supervisory',
        name: 'ecpSupervisory',
        meta: {
            title: '财务推送检测',
            keepAlive: true
        },
        component: resolve => require(['~/views/MyTask/EcpMonitor'], resolve),

    },
    {
        path: '/interface_log',
        name: 'interfaceLog',
        meta: {
            title: '接口监控',
            keepAlive: true
        },
        component: resolve => require(['~/views/MyTask/InterfaceLog'], resolve),
    },
    {
        path: '/ecp_task',
        name: 'ecpTask',
        meta: {
            title: 'ecp接口监控',
            keepAlive: true
        },
        component: resolve => require(['~/views/MyTask/EcpTask'], resolve),
    },
    //个人中心，可能有修改密码，头像修改等路由
    {
        path: '/personal',
        name: 'Personal',
        meta: {
            title: '个人中心',
            keepAlive: true
        },
        component: resolve => require(['~/views/PersonalCenter'], resolve),
    }
    ,
    //报表
    {
        path: '/sales_account',
        name: 'Sales_account',
        meta: {
            title: '销售台账-订单明细',
            keepAlive: true
        },
        component: resolve => require(['~/views/Report/SalesAccount'], resolve),
    },
    {
        path: '/tax_statement',
        name: 'Tax_statement',
        meta: {
            title: '税金报表',
            keepAlive: true
        },
        component: resolve => require(['~/views/Report/TaxStatement'], resolve),
    },
    {
        path: '/tax_balance',
        name: 'Tax_balance',
        meta: {
            title: '回款对账单',
            keepAlive: true
        },
        component: resolve => require(['~/views/Report/TaxBalance'], resolve),
    },
    {
        path: '/report_item/:type/',
        name: 'Report_item',
        meta: {
            title: '订单明细报表',
            keepAlive: false
        },
        component: resolve => require(['~/views/Report/ReportItem'], resolve),
    },
    {
        path: '/report_pay/:type/',
        name: 'Report_pay',
        meta: {
            title: '支付单报表',
            keepAlive: false
        },
        component: resolve => require(['~/views/Report/ReportItem'], resolve),
    },
    {
        path: '/ml_store',
        name: 'ml_store',
        meta: {
            title: '仓库管理',
            keepAlive: true
        },

        component: resolve => require(['~/views/rebate/mlstore'], resolve),
    },

    {
        path: '/sales_account_order',
        name: 'Sales_account_order',
        meta: {
            title: '销售台账-订单',
            keepAlive: true
        },
        component: resolve => require(['~/views/Report/SalesAccountOrder'], resolve),
    },
    {
        path: '/batch_stock',
        name: 'batch_stock',
        meta: {
            title: '库存',
            keepAlive: true
        },
        component: resolve => require(['~/views/rebate/batchStock'], resolve),
    },
    {
        path: '/ml_terminal',
            name: 'ml_terminal',
        meta: {
        title: '仓库管理',
            keepAlive: true
    },

        component: resolve => require(['~/views/rebate/terminal'], resolve),
    },

    {
        path: '/mlrebaterule',
            name: 'mlrebaterule',
        meta: {
        title: '返利规则',
            keepAlive: true
        },

        component: resolve => require(['~/views/rebate/rebateRule'], resolve),
    },
    {
        path: '/mlverifrec',
            name: 'mlverifrec',
        meta: {
        title: '收款核销',
            keepAlive: true
        },

        component: resolve => require(['~/views/rebate/verifRec'], resolve),
    }, {
    path: '/Specia_Address',
        name: 'Specia_Address',
        meta: {
        title: '异常地址',
            keepAlive: true
    },
    component: resolve => require(['~/views/Setting/SpeciaAddress'], resolve),
    },
    {
        path: '/Article',
            name: 'article',
            meta: {
            title: '文章列表',
                keepAlive: false
            },
        component: resolve => require(['~/views/Article'], resolve),
    },
    {
        path: '/Article/edit',
            name: 'articleEdit',
        
            meta: {
                title: '编辑文章',
                keepAlive: false
            },
        component: resolve => require(['~/views/Article/edit'], resolve),
    },
    {
        path: '/Region',
        name: 'region',
        meta: {
            title: '地址管理',
            keepAlive: false
        },
        component: resolve => require(['~/views/AddressManage'], resolve),
    },





    // 路由 path: '*' 必须在最后一个
    // { path: '*', redirect: '/', hidden: true }
]


// WEBPACK FOOTER //
// ./src/router/mainRouter.js